import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { taxesEnabled, getTaxPercentage } from '../../data/purchase-service';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencyValue } from '../../data/utils/getCurrencyValue';
import { getLabel, labels } from '../../data/labels';
import AmountBetslipForm from './AmountBetslipForm';
import BetslipButtons from './BetslipButtons';
import StakesPicker from './StakesPicker';
import { UserContext } from '../../data/betslip/UserConf';
import AdviceToReachBonusContainer from '../AdviceToReachBonusContainer';
import BetOptionsSection from './BetOptionsSection';
function PotentialWinBox(props) {
	const betslipContext = useContext(BetslipContext);
    const userContext = useContext(UserContext);
    let betslipData = betslipContext.getBetslipData();
    const conf = getConfiguration();
    const couponKey = props.couponKey;
    const container = props.container;
    const coupon = betslipData.coupons[couponKey];
	const totalTaxAmount = coupon.totalTaxAmount? coupon.totalTaxAmount : 0;
	const showTaxes = taxesEnabled() && totalTaxAmount > 0;
    let potentialWinning = getCurrencyValue(coupon.potentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let potentialWinMin =  getCurrencyValue(coupon.minPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let potentialWinMax =  getCurrencyValue(coupon.maxPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let amountSrc = 0;

    const stakeTaxedJustAdvice = betslipContext.stakeTaxConfiguration.enabled && 
	 							 betslipContext.stakeTaxConfiguration.type === 'advice_for_online_distro';

    const stakeTaxedForPurchase = betslipContext.stakeTaxConfiguration.enabled && 
	  							  betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase';
	let stakeTaxedAmountSrc = 0;
	let stakeTaxedPotentialWinning = 0;
	let stakeTaxedMinPotentialWinning = 0; // only for systembets
	let stakeTaxedMaxPotentialWinning = 0; // only for systembets

    
    function changeVarOdd(type) {
        if (coupon.oddVariation === 'NEVER') {
            coupon.oddVariation = 'ALWAYS';
        } else {
            coupon.oddVariation = 'NEVER';
        }
    	betslipContext.setBetslipData(betslipData, true);
    }
    
    // bonusMulti
    let bonusDataMulti = null;
    let potentialWinningNoBonusMulti = 0;
    let bonusWinMulti = 0;
    let descBonusMulti = "Bonus";
    
    // bonusSystem
    let bonusSystemData = null;
    let descBonusSystem = "Bonus";
    
    if (container === 'singlebets') {
    	amountSrc = coupon.amountSingle;
    	if(stakeTaxedJustAdvice || stakeTaxedForPurchase){
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountSingle;
    	}
    	
    } 
    else if (container === 'multibets') {
    	amountSrc = coupon.amountMulti;
    	bonusDataMulti = coupon.multipleBonus;
    	if (bonusDataMulti && bonusDataMulti.applied) {
    		potentialWinningNoBonusMulti = getCurrencyValue(bonusDataMulti.potentialWinningNoBonus, conf.cs.m, conf.cs.nd, conf.cs.ct);
    		bonusWinMulti = getCurrencyValue(bonusDataMulti.bonusAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
    		descBonusMulti = bonusDataMulti.description;
    	}
    	if(stakeTaxedJustAdvice || stakeTaxedForPurchase){
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountMulti;
    	}
    } 
    else {
    	amountSrc = coupon.amountSystem;
    	bonusSystemData = coupon.bonusSystemData;
    	if (bonusSystemData && bonusSystemData.applied) {
    		descBonusSystem = bonusSystemData.description && bonusSystemData.description !== "" ? bonusSystemData.description : descBonusSystem;
    	} 
    	else {
    		bonusSystemData = {
    			applied : false	
    		};
    	}
    	if(stakeTaxedJustAdvice || stakeTaxedForPurchase){
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountSystem;
    	}
    }
    
    const showAdvise = coupon.selectedContainer === 'multibets' && betslipContext.toGetBonusAdvise && betslipContext.toGetBonusAdvise.showAdvise;

	let totalAmount = getCurrencyValue(amountSrc, conf.cs.m, conf.cs.nd, conf.cs.ct);
    
    let stakeTaxedTotalAmount = null;
    const showTaxedTotalAmount = stakeTaxedForPurchase; // TO remove definetely if in the future we wont have a skin that requires it
	if(stakeTaxedJustAdvice || stakeTaxedForPurchase){
		stakeTaxedTotalAmount = getCurrencyValue(stakeTaxedAmountSrc, conf.cs.m, conf.cs.nd, conf.cs.ct);
		stakeTaxedPotentialWinning = getCurrencyValue(coupon.stakeTaxedPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
		stakeTaxedMinPotentialWinning =  getCurrencyValue(coupon.stakeTaxedMinPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
		stakeTaxedMaxPotentialWinning =  getCurrencyValue(coupon.stakeTaxedMaxPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
	}
	
    let taxedStakeAmountLabel = labels['betslip.taxed_stake'];
    let taxedStakeWinningLabel = labels['betslip.taxed_stake_winning'];
    if(stakeTaxedJustAdvice || stakeTaxedForPurchase){
    	taxedStakeAmountLabel = taxedStakeAmountLabel.replace(/{{PERCENTAGE}}/g,  betslipContext.stakeTaxConfiguration.percentage / 100 + "%");
    }
    
 // MAX PAID STUFF, IF THE CUSTOMER HAS IT IN ITS CONFIGURATION
    let maxPaidPotentialWinning = null;
    let maxPaidPotentialWinMin =  null;
    let maxPaidPotentialWinMax =  null;
    let maxPaidStakeTaxedPotentialWinning = null;
    
    if(container === 'systembets' ){
    	if(conf.sbmw !== 0 && conf.mwspw){
    		if(coupon.potentialWinning > conf.sbmw){
    			maxPaidPotentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if(coupon.minPotentialWinning > conf.sbmw){
    			maxPaidPotentialWinMin = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if(coupon.maxPotentialWinning > conf.sbmw){
    			maxPaidPotentialWinMax = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if(coupon.stakeTaxedPotentialWinning > conf.sbmw){
    			maxPaidStakeTaxedPotentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    }
    else{
    	if(conf.mbmw !== 0 && conf.mwmpw){
    		if(coupon.potentialWinning > conf.mbmw){
    			maxPaidPotentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if(coupon.stakeTaxedPotentialWinning > conf.mbmw){
    			maxPaidStakeTaxedPotentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    }
    const user = userContext.getUser();
	
	let wageringMessage = null;
   	if(user?.logged){
   		if(user.freebetCount > 0 && user.funbonusCount == 0){
   			wageringMessage = getLabel('freebet.enabled');
   		}
   		else if(user.freebetCount == 0 && user.funbonusCount > 0){
   			wageringMessage = getLabel('funbonus.enabled');
   		}
   		else if(user.freebetCount > 0 && user.funbonusCount > 0){
   			wageringMessage = getLabel('freebet_funbonus.enabled');
   		}
   	}
	
	return (
        <>
	    	{showAdvise &&
            <AdviceToReachBonusContainer bonusAdvice={betslipContext.toGetBonusAdvise.bonusAdvise} isBetslip={true} />
                /*<div className={"adviseToReachBonusContainer betslipAdvise"}> 
                    <span className={"iconContainer"}> <i className={"fas fa-gift"} /> </span>
                    <span className={"textContainer"}>  {betslipContext.toGetBonusAdvise.bonusAdvise} </span> 
                </div>*/
	    	}
            {container === 'multibets' && conf.bak?.mob === true &&
                <StakesPicker couponKey={couponKey} 
                              isEventForm={false} />
            }
            <div className="vincita-potenziale">
                {(container === 'singlebets' || container === 'systembets') &&
                    <>
                        <div className="box-vincita-potenziale d-sx grassetto">{labels['betslip.total_amount']}</div>
                        <div className="box-vincita-potenziale d-dx grassetto">
                            <span className="">{totalAmount}</span>
                        </div>
                    </>
                }
                
                {
                	container === 'singlebets' && betslipContext.betOptionsSectionMustBeShown() && <BetOptionsSection isSinglebet={true} />
                }
                
                {container === 'multibets' &&
                    <>
                    	{
                    		betslipContext.betOptionsSectionMustBeShown()?
                    		<BetOptionsSection />
                    		:
                    		<div className="box-vincita-potenziale d-sx grassetto">{labels['betslip.stake']}</div>
                    	}
                        <div className="input-puntata_bottone">
                            <AmountBetslipForm couponKey={couponKey} isEventForm={false} />
                        </div>						
                        <div className="box-vincita-potenziale d-sx grassetto">{labels['betslip.total_odds']}</div>
                        <div className="box-vincita-potenziale d-dx">
                            <span className="grassetto">{coupon.totalOdd}</span>
                        </div>
                        {bonusDataMulti && bonusDataMulti.applied &&
                            <>
                                <div className="box-vincita-potenziale d-sx grassetto">{descBonusMulti}</div>
                                <div className="box-vincita-potenziale d-dx grassetto">{bonusWinMulti}</div>
                                <div className="box-vincita-potenziale d-sx grassetto verde">{labels['betslip.winnings']}</div>
                                <div className="box-vincita-potenziale d-dx">
                                    <span className="grassetto verde">{potentialWinningNoBonusMulti}</span>
                                </div>
                            </>
                        }
                    </>
                }
    			{
    				showTaxedTotalAmount && <>
    					<div className="box-vincita-potenziale d-sx grassetto">{taxedStakeAmountLabel}</div>
    					<div className="box-vincita-potenziale d-dx">
    						<span className="grassetto">{stakeTaxedTotalAmount}</span>
    					</div>
    				</>
    			}
                {container === 'systembets' &&
                    <>                      
                        <div className="box-vincita-potenziale d-sx">{labels['betslip.combs']}</div>
                        <div className="box-vincita-potenziale d-dx">{coupon.totalCombs}</div>
                        <div className="box-vincita-potenziale d-sx">{labels['betslip.min_winnings']}</div>
                        <div className="box-vincita-potenziale d-dx">{maxPaidPotentialWinMin? maxPaidPotentialWinMin : potentialWinMin}</div>
                        <div className="box-vincita-potenziale d-sx">{labels['betslip.max_winnings']}</div>
                        <div className="box-vincita-potenziale d-dx">{maxPaidPotentialWinMax? maxPaidPotentialWinMax : potentialWinMax}</div>
                        {bonusSystemData.applied &&
                            <>
                                <div className="box-vincita-potenziale d-sx grassetto">{descBonusSystem.toUpperCase()}</div>
                                <div className="box-vincita-potenziale d-dx"></div>
                                <div className="box-vincita-potenziale d-sx">{"Bonus Min."} </div>
                                <div className="box-vincita-potenziale d-dx">{getCurrencyValue((bonusSystemData.bonusMin * conf.cs.m), conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                                <div className="box-vincita-potenziale d-sx">{"Bonus Max."}</div>
                                <div className="box-vincita-potenziale d-dx">{getCurrencyValue((bonusSystemData.bonusMax * conf.cs.m), conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                            </>
                        }
                    </>
                }
                
            	{showTaxes && <>
   					<div className="box-vincita-potenziale grassetto d-sx">{labels['printer.plain_ticket.footer.tax']} {'(' + getTaxPercentage() + ')'}</div>
   					<div className="box-vincita-potenziale d-dx">{getCurrencyValue(totalTaxAmount, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
   				</>}
                <div className="box-vincita-potenziale d-sx grassetto verde">{labels['betslip.potential_winnings']}</div>
                <div className="box-vincita-potenziale d-dx">
                    <span className="grassetto verde">
                    	{stakeTaxedForPurchase? 
                    		 (maxPaidStakeTaxedPotentialWinning? maxPaidStakeTaxedPotentialWinning : stakeTaxedPotentialWinning) 
                    		 : 
                    		 (maxPaidPotentialWinning? maxPaidPotentialWinning : potentialWinning)
                    	}
                    </span>
                </div>
                {
                	stakeTaxedJustAdvice && <>
    	                <div className="box-vincita-potenziale d-sx grassetto">{taxedStakeWinningLabel}</div>
    	                <div className="box-vincita-potenziale d-dx">
    	                	<span className="grassetto">{maxPaidStakeTaxedPotentialWinning? maxPaidStakeTaxedPotentialWinning : stakeTaxedPotentialWinning}</span>
    	                </div>
                	</>
                }
                
            </div>
            {conf.ovs?.tgs &&
                <div className="d-flex align-items-center justify-content-start mt-4 mb-4">
                    <span>{labels['betslip.odds_variation_toggle.label']}</span>
                    <label className="custom-switch-2 ml-auto">
                        <input type="checkbox" checked={coupon.oddVariation !== 'NEVER'} onChange={changeVarOdd} />
                        <span className="custom-slider-2 round"></span>
                    </label>
                </div>
            }
            
            {
            	wageringMessage &&                    
            	(
	              <div className={"adviseFreebetContainer"}> 
                    <span className={"iconContainer"}> <i className={"fas fa-thumbs-up"} /> </span>
                    <span className={"textContainer"}>  {wageringMessage} </span> 
                  </div>
            	)
            }
            
           <BetslipButtons />
        </>
    );
}

export default PotentialWinBox;